import { useRef as u, useEffect as t } from "react";
const s = (r) => {
  const e = u();
  return t(() => (e.current = r, () => {
    e.current = void 0;
  })), e.current;
};
export {
  s as default
};
//# sourceMappingURL=usePreviousValue.es.js.map
